import {
  getLichSuNhienLieuKho,
  getLichSuThucPhamKho,
  getThucPhamKho,
  getThucPhamKhoNL,
  getXuatKho,
} from '@/services/ThucPhamKho/thucphamkho';
import { useState } from 'react';
import type { ThucPhamKho as IThucPhamKho } from '@/services/ThucPhamKho';
import type { DanhMucThucPham as IDanhMucThucPham } from '@/services/DanhMucThucPham';
import moment from "moment-timezone";
import axios from "@/utils/axios";
import {ip3} from "@/utils/constants";
import {NhomLoaiThucPham} from "@/models/xuatbaocaothucpham";

export default () => {
  const [danhSach, setDanhSach] = useState<IThucPhamKho.Record[]>([]);
  const [danhSachNL, setDanhSachNL] = useState<IThucPhamKho.Record[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [total, setTotal] = useState<number>(0);
  const [totalNL, setTotalNL] = useState<number>(0);
  const [record, setRecord] = useState<IThucPhamKho.Record>({} as any);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [pageNL, setPageNL] = useState<number>(1);
  const [limitNL, setLimitNL] = useState<number>(10);
  const [cond, setCondition] = useState<any>({ loaiNguyenLieu: 'Thực phẩm' });
  const [filterInfo, setFilterInfo] = useState<any>({});
  const [edit, setEdit] = useState<boolean>(false);
  const [visibleForm, setVisibleForm] = useState<boolean>(false);
  const [dsThucPham, setDsThucPham] = useState<IDanhMucThucPham.Record[]>([]);
  const [dsNhienLieu, setDsNhienLieu] = useState<IDanhMucThucPham.Record[]>([]);
  const [danhSachTruong, setDanhSachTruong] = useState([]);
  const [timeStart, setTimeStart] = useState<any>(moment().startOf('date').toDate());
  const [timeEnd, setTimeEnd] = useState<any>(moment().endOf('date').toDate());
  const [timeStartLS, setTimeStartLS] = useState<any>(moment().startOf('date').toDate());
  const [timeEndLS, setTimeEndLS] = useState<any>(moment().endOf('date').toDate());
  const getThucPhamKhoModel = async (
    donViId?: string,
    ngay?: number,
    thang?: number,
    nam?: number,
  ) => {
    setLoading(true);
    const response = await getThucPhamKho({
      page,
      limit,
      cond: { ...cond, loaiNguyenLieu: 'Thực phẩm', ngay, thang, nam },
      donViId,
      timeStart,
      timeEnd,
    });
    setDanhSach(response?.data?.data?.result ?? []);
    setTotal(response?.data?.data?.total);
    setLoading(false);
  };
  const getThucPhamKhoModelNhienLieu = async (
    donViId?: string,
    ngay?: number,
    thang?: number,
    nam?: number,
  ) => {
    setLoading(true);
    const response = await getThucPhamKhoNL({
      page,
      limit,
      cond: { ...cond, loaiNguyenLieu: 'Nhiên liệu', ngay, thang, nam },
      donViId,
      timeStart,
      timeEnd,
    });
    setDanhSachNL(response?.data?.data?.result ?? []);
    setTotalNL(response?.data?.data?.total);
    setLoading(false);
  };
  const getLichSuThucPhamKhoModel = async (
    donViId?: string,
    ngay?: number,
    thang?: number,
    nam?: number,
  ) => {
    setLoading(true);
    const response = await getLichSuThucPhamKho({
      page,
      limit,
      cond: { ...cond, loaiNguyenLieu: 'Thực phẩm', ngay, thang, nam },
      donViId,
      timeStart: timeStartLS,
      timeEnd: timeEndLS,
    });
    setDanhSach(response?.data?.data?.result ?? []);
    setTotal(response?.data?.data?.total);
    setLoading(false);
  };
  const getLichSuThucPhamKhoModelNhienLieu = async (
    donViId?: string,
    ngay?: number,
    thang?: number,
    nam?: number,
  ) => {
    setLoading(true);
    const response = await getLichSuNhienLieuKho({
      page,
      limit,
      cond: { ...cond, loaiNguyenLieu: 'Nhiên liệu', ngay, thang, nam },
      donViId,
      timeStart: timeStartLS,
      timeEnd: timeEndLS,
    });
    setDanhSachNL(response?.data?.data?.result ?? []);
    setTotalNL(response?.data?.data?.total);
    setLoading(false);
  };

  const getDSThucPham = async (donViId) => {
    const result = await axios.get(`${ip3}/danh-muc-thuc-pham/pageable/v2`, {
      params: {
        donViId,
      },
    });
    setDsThucPham(result?.data?.data?.result?.filter((item: IDanhMucThucPham.Record)=>{
      return item.nhomLoaiThucPham !== NhomLoaiThucPham.NANG_LUONG;
    }));
    setDsNhienLieu(result?.data?.data?.result?.filter((item: IDanhMucThucPham.Record)=>{
      return item.nhomLoaiThucPham === NhomLoaiThucPham.NANG_LUONG;
    }));
  };

  return {
    danhSach,
    record,
    setRecord,
    loading,
    setLoading,
    getThucPhamKhoModel,
    total,
    setTotal,
    page,
    setPage,
    limit,
    setLimit,
    cond,
    setCondition,
    filterInfo,
    setFilterInfo,
    setVisibleForm,
    edit,
    setEdit,
    visibleForm,
    setDsThucPham,
    dsThucPham,
    danhSachTruong,
    setDanhSachTruong,
    timeStart,
    timeEnd,
    setTimeEnd,
    setTimeStart,
    getThucPhamKhoModelNhienLieu,
    danhSachNL,
    getDSThucPham,
    dsNhienLieu,
    setDanhSachNL,
    totalNL,
    timeEndLS,
    timeStartLS,
    getLichSuThucPhamKhoModel,
    getLichSuThucPhamKhoModelNhienLieu,
    pageNL,limitNL
  };
};
